<div class="vs-section-content has-outline-menu" *ngFor="let detail of itemsCoreData; let i = index"
  [ngClass]="{'disabled-vs-content': detail['status'] === 'Desactivado'}">
  <div class="vs-crud-menu">
    <button *ngIf="enableEdit" type="button" [disabled]="!mantenienceSection"
      [ngClass]="mantenienceSection ? 'vs-btn-crud' : 'vs-btn-crud-disabled'" matTooltip="Editar item"
      (click)="sendItemEdit(detail)">
      <mat-icon>edit</mat-icon>
    </button>
    <button *ngIf="enableDelete" type="button" [disabled]="!mantenienceSection"
      [ngClass]="mantenienceSection ? 'vs-btn-crud' : 'vs-btn-crud-disabled'" matTooltip="Eliminar item"
      (click)="sendItemDelete(detail)">
      <mat-icon>delete</mat-icon>
    </button>
  </div>
  <div class="content vs-image-text" [ngClass]="{'no-img': detail.type == 1}"
    style="justify-content: space-between;gap: 5%; display: flex;">
    <p *ngIf="detail.type == 1" [innerHTML]="detail.name || detail['title']"></p>
    <img *ngIf="detail.type == 2 && detail.img" [src]="detail.img" [alt]="'img-info' + detail.id"
      onerror="this.onerror= null; this.src = 'assets/images/img-placeholder.png'">
    <img *ngIf="detail.type == 2 && detail.img2" [src]="detail.img2" [alt]="'img-info' + detail.id"
      onerror="this.onerror= null; this.src = 'assets/images/img-placeholder.png'">
    <img *ngIf="detail.type == 2 && detail.img3" [src]="detail.img3" [alt]="'img-info' + detail.id"
      onerror="this.onerror= null; this.src = 'assets/images/img-placeholder.png'">
    <!-- <p *ngIf="detail['subTitle']">{{detail['subTitle']}}</p> -->
  </div>
</div>
<div class="w-100 text-center" *ngIf="!itemsCoreData.length">
  <h2 class="mb-4">No existen datos habilitados</h2>
</div>